import { useEffect } from "react"
import { KEYBOARD_KEYS } from "@/shared/components/image-gallery/constants"

interface UseGalleryKeyboardNavigationParams {
  enabled: boolean
  onPrev: () => void
  onNext: () => void
  onClose: () => void
}

const useGalleryKeyboardNavigation = ({ enabled, onPrev, onNext, onClose }: UseGalleryKeyboardNavigationParams) => {
  useEffect(() => {
    if (!enabled) return

    const handleKey = (event: KeyboardEvent) => {
      if (event.altKey || event.ctrlKey || event.metaKey) return
      if (event.key === KEYBOARD_KEYS.left) {
        event.preventDefault()
        onPrev()
      } else if (event.key === KEYBOARD_KEYS.right) {
        event.preventDefault()
        onNext()
      } else if (event.key === KEYBOARD_KEYS.escape) {
        event.preventDefault()
        onClose()
      }
    }

    window.addEventListener("keydown", handleKey)
    return () => window.removeEventListener("keydown", handleKey)
  }, [enabled, onPrev, onNext, onClose])
}

export { useGalleryKeyboardNavigation }
